module.exports = __webpack_public_path__ + "img/hardyShoulders1.74d78a07.png";